// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_fk-j";
export var fulfillmentFormRail = "_fk-i";
export var headerTitleRow = "_fk-l";
export var orderDetailsWrapper = "_fk-g";
export var orderLinkTrigger = "_fk-2";
export var paymentInformationGrid = "_fk-q";
export var paymentSummaryColumn = "_fk-r";
export var phoneShipmentPickerButton = "_fk-e";
export var phoneShipmentPickerButtonContent = "_fk-f";
export var phoneShipmentPickerButtonWrapper = "_fk-d";
export var phoneShipmentPickerTrigger = "_fk-c";
export var shipmentContainer = "_fk-k";
export var shipmentDetailsMainPane = "_fk-h";
export var shipmentNavigationCard = "_fk-a";
export var shipmentNavigationEdgeTrigger = "_fk-6";
export var shipmentNavigationRail = "_fk-3";
export var shipmentNavigationRailEnter = "_fk-5";
export var shipmentNavigationRailHeader = "_fk-9";
export var shipmentNavigationRailOverlay = "_fk-4";
export var shipmentNavigationScrim = "_fk-7";
export var shipmentSummaryFact = "_fk-n";
export var shipmentSummaryGrid = "_fk-m";
export var shipmentSummaryMetadataRow = "_fk-o";
export var shipmentSummaryTags = "_fk-p";
export var shipmentWorkspace = "_fk-0";
export var shipmentWorkspaceBodyTablet = "_fk-8";
export var shipmentWorkspaceContent = "_fk-b";
export var shipmentWorkspaceHeader = "_fk-1";